import React from 'react';

const NetSuiteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_11026_2015835)">
      <path
        d="M0.746399 4.66486H3.8869V12.1252H5.45053V15.0405H0.746399V4.66486ZM15.2828 11.5289H12.1423V4.06856H10.5787V1.15332H15.2828V11.5289Z"
        fill="#CBCBCB"/>
      <path
        d="M0.0175781 0.4375H9.94264V8.95794L6.12633 4.04179H0.0175781V0.4375ZM15.9984 15.769H6.07332V7.24855L9.88963 12.1647H15.9984"
        fill="#07132B"/>
      <path
        d="M0.733154 4.45978H3.87366V11.9201H5.43729V14.8354H0.733154V4.45978ZM15.2696 11.3238H12.1291V3.86348H10.5655V0.948242H15.2696V11.3238Z"
        fill="#CBCBCB"/>
      <path
        d="M0.0043335 0.232422H9.92939V8.75287L6.11308 3.83672H0.0043335V0.232422ZM15.9851 15.5639H6.06008V7.04348L9.87639 11.9596H15.9851"
        fill="#07132B"/>
    </g>
    <defs>
      <clipPath id="clip0_11026_2015835">
        <rect width="16" height="15.5463" fill="white" transform="translate(0 0.226562)"/>
      </clipPath>
    </defs>
  </svg>
);

export default NetSuiteIcon;
